import React from 'react';
import { Popover } from 'antd';
import { SystemConfiguration } from 'src/utils/system-configuration';
import { LevelName } from 'src/utils/enums';
import getCountryFlag from 'src/utils/countries-flags';
import CustomIcon, { IconType } from '../../../shared/custom-icon/custom-icon';
import { AdvancedProtectionRow } from '../../advanced-protection-row/advanced-protection-row';
import './quick-start-blocked-items.scss';

interface QuickStartBlockedItemsProps {
    serviceLevel?: string;
    renderMode?: 'flat' | 'popover';
}

const QuickStartBlockedItems: React.FC<QuickStartBlockedItemsProps> = ({ serviceLevel, renderMode = 'popover' }) => {
    const { categoryDtoList, getCountriesMapByName } = SystemConfiguration.getInstance();

    const sortedBlockCategories = categoryDtoList
        .filter(c => c.blockedByDefault)
        .map(c => c.categoryName)
        .sort((a, b) => a.localeCompare(b));

    const sortedHighRiskRegions = Object.values(getCountriesMapByName)
        .filter(r => r.highRisk)
        .sort((a, b) => a.countryName.localeCompare(b.countryName));

    const renderBlockedList = (items: string[], isRegion = false) => (
        <div className="blocked-list">
            {items.map((item, index) => {
                const FlagSvg = isRegion ? getCountryFlag(item) : null;
                return (
                    <div className="item" key={item}>
                        {FlagSvg && <FlagSvg />}
                        <div className="name">{isRegion ? sortedHighRiskRegions[index].countryName : item}</div>
                    </div>
                );
            })}
        </div>
    );

    const renderContent = (title: string, content?: React.ReactNode) => (
        <div className="quick-start-blocked-item" key={title.replace(/\s+/g, '-')}>
            <div className="quick-start-blocked-title">{title}</div>
            {renderMode === 'flat' ? content : (
                <Popover overlayClassName="quick-start-blocked-popover" placement="top" trigger={['hover', 'click']} content={content}>
                    {!!content && <CustomIcon type={IconType.INFO} className="info-icon" />}
                </Popover>
            )}
        </div>
    );

    const items: {title: string, content?: React.ReactNode}[] = [
        {
            title: 'Blocked Countries',
            content: renderBlockedList(sortedHighRiskRegions.map(r => r.countryCode), true),
        },
        {
            title: 'Blocked Web Categories',
            content: renderBlockedList(sortedBlockCategories),
        },

    ];

    if (serviceLevel === LevelName.GOLD) {
        items.push({
            title: 'Blocked Profiles',
            content: (
                <div className="blocked-list">
                    {['Virus', 'Spyware', 'DNS', 'Vulnerability'].map(type => (
                        <AdvancedProtectionRow key={type} type={type} value="block" />
                    ))}
                </div>
            ),
        });
    } else if (serviceLevel === LevelName.SILVER) {
        items.push({
            title: 'DNS Protection',
            content: null,
        });
    }

    return (
        <div className={`quick-start-blocked-wrapper ${renderMode}`}>
            {items.map(item => renderContent(item.title, item.content))}
        </div>
    );
};

export default QuickStartBlockedItems;
